import Vue from 'vue';
import App from './App.vue';

import { mixins } from './mixins/index.js';
import router from './router/index.js';
import store from './store';

import './assets/scss/drawer.scss';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-toast-notification/dist/theme-sugar.css';

import 'vue-calendar-heatmap/dist/vue-calendar-heatmap.css';
import VueCalendarHeatmap from 'vue-calendar-heatmap/dist/vue-calendar-heatmap.common';

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import Chat from 'vue-beautiful-chat';
Vue.use(Chat);

Vue.use(VueCalendarHeatmap);

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueToast from 'vue-toast-notification';

Vue.config.productionTip = false;

import {
    faPlus,
    faAngleDown,
    faBars,
    faDownload,
    faTrash,
    faListCheck,
    faPenToSquare,
    faAngleLeft,
    faAngleRight,
    faInfoCircle,
    faUsers,
    faAnglesLeft,
    faAnglesRight,
    faClipboard,
    faEnvelope,
    faUserPlus,
    faCircleXmark,
    faUserPen,
    faCube,
    faCircleCheck,
    faXmark,
    faCircleExclamation
} from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(
    faPlus,
    faBars,
    faDownload,
    faTrash,
    faListCheck,
    faPenToSquare,
    faAngleLeft,
    faAngleRight,
    faAngleDown,
    faInfoCircle,
    faAnglesLeft,
    faAnglesRight,
    faUsers,
    faCube,
    faClipboard,
    faEnvelope,
    faUserPlus,
    faCircleXmark,
    faUserPen,
    faCircleCheck,
    faXmark,
    faCircleExclamation
);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueToast, {
    position: 'bottom-right',
    duration: 4000,
});

import VueApexCharts from 'vue-apexcharts';
import './registerServiceWorker';
Vue.use(VueApexCharts);

Vue.component('ApexChart', VueApexCharts);

Vue.mixin({
    methods: {
        ...mixins,
    },
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
